import React from 'react';
import { Link } from 'react-router-dom';

const CalendarPickupStack = ({ pickups, expanded, onToggle }) => {
  if (!pickups.length) return null;

  const visiblePickups = expanded ? pickups : pickups.slice(0, 1);

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 4,
        right: 4,

        zIndex: expanded ? 1000 : 5,
      }}
    >
      <div
        style={{
          background: '#0d6efd',
          borderRadius: 10,
          overflow: 'hidden',
          color: '#fff',
          boxShadow: expanded
            ? '0 10px 30px rgba(0,0,0,.25)'
            : '0 3px 10px rgba(0,0,0,.15)',
        }}
      >
        {visiblePickups.map((pickup) => (
          <Link
            key={pickup.id}
            to={`/pickups/${pickup.id}`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div
              style={{
                padding: 8,
                paddingBottom: 0,
                borderBottom: '3px solid rgb(255,255,255)',
              }}
            >
              <div>Delivery #{pickup.id}</div>

              <div>{pickup.driver?.name || 'Unassigned'}</div>
              <div>{pickup.user?.full_name || ''}</div>
            </div>
          </Link>
        ))}

        {!expanded && pickups.length > 1 && (
          <div
            style={{
              background: '#5194f9',
              padding: 8,
              paddingTop: 0,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggle();
            }}
          >
            +{pickups.length - 1} more
          </div>
        )}

        {expanded && (
          <div
            style={{
              background: '#5194f9',
              padding: 8,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggle();
            }}
          >
            Show less
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarPickupStack;
